
import { Testimonial } from 'client-website-ts-library/types';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class TestimonialCard extends Vue {
  @Prop()
  private readonly testimonial!: Testimonial;

  @Prop({ default: true })
  private readonly hasReadMoreButton!: boolean;

  @Prop({ default: false })
  private readonly hasAgentPhotos!: boolean;

  @Prop({ default: false })
  private readonly seeMoreTestimonials!: boolean;

  @Prop({ default: false })
  private readonly hasAgentName!: boolean;

  @Prop({ default: false })
  private readonly hasExtraHeight!: boolean;

  private cleanedContent = ''

  mounted() {
    this.cleanContent();
  }

  get formattedAddress(): string {
    const parts = [];

    if (this.testimonial.Address) parts.push(this.testimonial.Address);
    if (this.testimonial.Suburb) parts.push(this.testimonial.Suburb);

    return parts.join(', ');
  }

  @Watch('testimonial')
  cleanContent(): void {
    const el = document.createElement('div');

    el.innerHTML = this.testimonial.Description;

    this.cleanedContent = el.innerText;
  }

  popupActive = false

  showTestimonial(): void {
    this.popupActive = true;
  }

  hideTestimonial(): void {
    this.popupActive = false;
  }

  // getYouTubeIdOld() {
  //   let videoId = this.testimonial.VideoLink.split('v=')[1];
  //   const ampersandPosition = videoId.indexOf('&');
  //   if (ampersandPosition !== -1) {
  //     videoId = videoId.substring(0, ampersandPosition);
  //   }
  //   return videoId;
  // }

  getYouTubeId() {
    const url = this.testimonial.VideoLink;
    if (!url) return '';

    // Match common YouTube URL patterns
    const regex = /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/\s]{11})/i;
    const match = url.match(regex);
    return match ? match[1] : '';
  }
}
